import { storage } from 'BASE/common/util/util.storage';
import AnnouncementComponent from '#BASE/components/annoucement/annoucement.component';
import { actionTypes } from 'BASE/store/types';

export default {
    mixins: [AnnouncementComponent],
    props: {
        dialog: Object
    },
    data: function () {
        return {
            IsOrderByDesc: true,
            Annoucements: [],
            Detail: {},
            TotalPages: 1,            // 總共有多少分頁
            AnnouncementsPerPage: 10,  // 多少篇公告分一頁
            CurrentPage: 1,           // 當前分頁
            ContentTitle: "",         // 公告內文標題
            EffectiveTime: 5,   //單位分鐘
            EnableTop: false    //訊息置頂 (當從首頁跑馬燈或其它地方跳轉該公告頁時，對應的訊息是否置頂顯示)
        };
    },
    methods: {
        async getList() {
            let _this = this;
            _this.Annoucements = [];

            let _tag = _this.isLogin ? storage.keys.LOGIN_ANNOUCEMENTS : storage.keys.UNLOGIN_ANNOUCEMENTS;
            let _regAnnoucements = storage.local.get(_tag);
            if (_regAnnoucements) {
                _this.Annoucements = _regAnnoucements;
            }
            else {
                try {
                    let _result = await $.post(`/api/Annoucement/GetListWithReadMark/${_this.IsOrderByDesc}`);
                    if (_result) {
                        let _newExpiresTime = new Date().getTime() + (_this.EffectiveTime * 60 * 1000);
                        storage.local.set(_tag, _result, _newExpiresTime);
                        _this.Annoucements = _result;
                    }
                }
                catch (err) {
                    console.error(err);
                }
            }
            
            this.$store.dispatch(actionTypes.ANNOUNCEMENTS, { Announcements: _this.Annoucements });
            await this.updateUnreadAnnouncement();
            // 根據公告量的多寡取得要幾個分頁
            _this.getPages()

            //網址有夾帶ID取網址的資訊
            if (_this.$route.params.id) {
                let _id = _this.$route.params.id;
                _this.getDetail(_id);
                _this.setTop(_id);
            }
        },
        getPages() {
            let _this = this;
            _this.TotalPages = Math.ceil( _this.Annoucements.length / _this.AnnouncementsPerPage ); // Get a upward to its nearest integer 
        },
        setContent(id) {
            this.setContentTitle(id);
            return this.getDetail(id);
        },
        setContentTitle(id) {
            let _this = this;
            this.ContentTitle = "";
            $.each(_this.Annoucements, function (index, value) {
                if (value.ID == id) {
                    _this.ContentTitle = value.Title;
                    _this.SetAnnouncementRead(value);
                }
            });
            // Scroll to Top
            $('#AnnouncementPage').scrollTop(0);
            _this.announcementRead(id);
        },
        turnPageUp() {
            let _this = this;
            if ( _this.TotalPages > _this.CurrentPage ) {
                _this.CurrentPage = _this.CurrentPage + 1;
            }
        },
        turnPageDown() {
            let _this = this;
            if ( 1 < _this.CurrentPage ) {
                _this.CurrentPage = _this.CurrentPage - 1;
            }
        },
        jumpToPage(page) {
            let _this = this;
            _this.CurrentPage = page;
        },
        showAnnouncement(id, index){
            let _this = this;
            // 假如沒傳入參數  跳出列表中第一項公告
            if (!id) {
                if (_this.Annoucements[0]) {
                    _this.CurrentPage = 1;
                    _this.setContentTitle(_this.Annoucements[0].ID);
                    _this.getDetail(_this.Annoucements[0].ID);
                    _this.setTop(_this.Annoucements[0].ID);
                }
            }
            else {
                // 根據公告的index除以每頁可顯示的最大數量，取下限整數再+1
                let page = Math.floor( index / _this.AnnouncementsPerPage ) +1;
                _this.CurrentPage = page;

                _this.setContentTitle(id);
                _this.getDetail(id);
                _this.setTop(id);
            }
            
            _this.SetAnnouncementRead(id ? _this.Annoucements[index] : _this.Annoucements[0]);

            let _dialog = _this.$dialog.get('announcement');
            _dialog.show();
        },
        closeAnnouncement(){
            let _dialog = this.$dialog.get('announcement');
            _dialog.hide();
        },
        async announcementRead(id) {
            let _result = await $.post(`/api/Annoucement/SetToRead/${id}`);
        },
        //設置公告為已讀
        async SetAnnouncementRead(announcement) {
            if (!announcement.userRead) {
                announcement.userRead = true;
                await $.post(`/api/Annoucement/SetToRead/` + announcement.ID);
                storage.local.set(storage.keys.LOGIN_ANNOUCEMENTS, this.Annoucements, new Date().getTime() + (5 * 60 * 1000));
                this.$store.dispatch(actionTypes.ANNOUNCEMENTS, { Announcements: this.Annoucements });
                await this.updateUnreadAnnouncement(this.$store.state.userinfo.unreadAnnouncement-1);
            }
        },
    }
};